import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const VirtualConnectionDownstreamDatasourcesFilteredByTableQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamDatasourcesFilteredByTableQuery(
  $vizportalUrlId: String!,
  $selectedTableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    tablesConnection(filter: { id: $selectedTableId }) {
      nodes {
        downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
